import { FluentParser } from '@fluent/syntax';

const fluentParser: FluentParser = new FluentParser({ withSpans: false });

export default fluentParser;
